
























































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { mapState } from "vuex";

// Enums
import { Contexts } from "@/models/contexts";

// Types
import { IState } from "@/store";
import { IUser } from "@/models/users";
import { DataModules } from "@/store/modules/data";
import { ClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "user-notifications-list": () =>
      import(
        "@/components/app/global/userNotifications/userNotificationsList.vue"
      )
  },
  computed: {
    ...mapState({
      user: (state: IState) => state.user,
      windowWidth: (state: IState) => state.ui.window.width,
      hasUnreadNotifications(state, getters) {
        return getters[`data/${DataModules.USER_NOTIFICATIONS}/hasUnread`]();
      }
    })
  }
})
export default class AdminNavigationFooter extends Vue {
  // Data
  public user!: IUser;
  public readonly hasUnreadNotifications!: boolean;
  public context: Contexts = Contexts.ADMIN;
  public isExpanded = false;
  public windowWidth!: number;
  public readNotificationsScope = "";
  public unReadNotificationsScope = "";
  public logomarkUrl =
    "/assets/images/interface/logos/upmind—logomark—white-on-transparent.svg";
  public readonly clientDashboardRoute = ClientRoutes.DASHBOARD;

  public created() {
    this.readNotificationsScope = this.$store.getters[
      `data/${DataModules.USER_NOTIFICATIONS}/loggedUserScope`
    ]();
    this.unReadNotificationsScope = this.$store.getters[
      `data/${DataModules.USER_NOTIFICATIONS}/loggedUserUnreadScope`
    ]();
    this.$bus.$on("closeNavFooter", () => {
      this.isExpanded = false;
    });
  }

  public expandFooter() {
    this.isExpanded = !this.isExpanded;
    if (this.isExpanded) {
      this.$store.commit("ui/collapseNav", false);
    }
  }

  @Watch("windowWidth")
  public onWindowWidthChange(width, oldWidth) {
    if (width < oldWidth) {
      this.isExpanded = false;
    }
  }

  public onScroll(props) {
    if (!this.$refs.userNotificationList) {
      return;
    }
    // @ts-ignore
    this.$refs.userNotificationList.onScroll(props);
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.USER_NOTIFICATIONS,
      ignoreDependants: true,
      scope: this.readNotificationsScope,
      vm: this
    });
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.USER_NOTIFICATIONS,
      ignoreDependants: true,
      scope: this.unReadNotificationsScope,
      vm: this
    });
  }
}
